import { EventTypes } from 'redux-segment';
import { ref } from '../config/constants'

const initState = {
  loading: false,
  list: {}
}

const WATCHLIST_SYMBOL_ADD = 'WATCHLIST_SYMBOL_ADD'
const WATCHLIST_SYMBOL_REMOVE = 'WATCHLIST_SYMBOL_REMOVE'
const WATCHLIST_FETCH = 'WATCHLIST_FETCH'
const WATCHLIST_FETCH_SUCCESS = 'WATCHLIST_FETCH_SUCCESS'
// const WATCHLIST_FETCH_ERROR = 'WATCHLIST_FETCH_ERROR'

const watchlistFetch = () => ({
  type: WATCHLIST_FETCH,
  loading: true,
})

const watchlistFetchSuccess = (list) => ({
  type: WATCHLIST_FETCH_SUCCESS,
  loading: false,
  list,
})

// const watchlistFetchError = () => ({
//   type: WATCHLIST_FETCH_ERROR,
//   loading: false,
// })

const addSymbol = (entry) => ({
  type: WATCHLIST_SYMBOL_ADD,
  symbol: entry,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        event: WATCHLIST_SYMBOL_ADD,
        properties: {
          symbol: entry.symbol
        },
      },
    },
  },
})

const removeSymbol = (symbol) => ({
  type: WATCHLIST_SYMBOL_REMOVE,
  symbol,
  meta: {
    analytics: {
      eventType: EventTypes.track,
      eventPayload: {
        event: WATCHLIST_SYMBOL_REMOVE,
        properties: {
          symbol,
        },
      },
    },
  },
})

export const fetchWatchlist = () => {
  return (dispatch, getState) => {
    dispatch(watchlistFetch())
    const { currentUser } = getState().user
    const watchlist = ref.child(`users/${currentUser.info.uid}/watchlist`);
    watchlist.once('value', (snapshot) => {
      const list = snapshot.val() || {};
      dispatch(watchlistFetchSuccess(list))
    });
  }
}

export const addSymbolToWatchlist = (entry) => {
  return (dispatch, getState) => {
    const { currentUser } = getState().user
    ref.child(`users/${currentUser.info.uid}/watchlist`)
      .push(entry)
      .then(() => {
        dispatch(addSymbol(entry))
        dispatch(fetchWatchlist())
      })
  }
}

export const removeSymbolFromWatchlist = (key, symbol) => {
  return (dispatch, getState) => {
    const { currentUser } = getState().user
    ref.child(`users/${currentUser.info.uid}/watchlist/${key}`).remove()
      .then(() => {
        dispatch(removeSymbol(symbol))
        dispatch(fetchWatchlist())
      })
  }
}


// REDUCER
export default (state = initState, action) => {
  switch (action.type) {
    case WATCHLIST_SYMBOL_ADD:
    case WATCHLIST_SYMBOL_REMOVE:
      return {...state, symbol: action.symbol}

    case WATCHLIST_FETCH_SUCCESS:
      return {...state, list: action.list, loading: action.loading}

    case WATCHLIST_FETCH:
      return {...state, list: action.list, loading: action.loading}

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/watchlist.js